const BEM_BASE = 'bi-card-block';

const HIERARCHY = 'article-hierarchy';

const COLUMN_CLASSES = 'column column--half bi-card-block__column';

const HIERARCHY_SHORT = 'article-hierarchy-short';

const LANDSCAPE_WITH_AD = 'article-landscape-with-ad';

export { BEM_BASE, COLUMN_CLASSES, HIERARCHY, HIERARCHY_SHORT, LANDSCAPE_WITH_AD };
